import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
     providedIn: 'root',
})
export class BookingErrorHandlerService {
     constructor(public toastrService: ToastrService) {}

     run(ctxCode) {
          let appLang = window.appLang;

          const ERROR_MESSAGES = {
               ACTIVITY_FULL: appLang.PLANNING__ACTIVITY_FULL,
               ACTIVITY_LIMIT_REACHED:
                    appLang.PLANNING__RES_ACTIVITY_LIMIT_REACHED,
               GROUP_LIMIT_REACHED: appLang.PLANNING__RES_GROUP_LIMIT_REACHED,
               PERIOD_EXCEEDED: appLang.PLANNING__RES_PERIOD_EXCEEDED,
               NO_ACTIVE_ACCESS: appLang.PLANNING__NO_ACTIVE_ACCESS,
               SPECIAL_ACCESS_REQUIRED:
                    appLang.PLANNING__SPECIAL_ACCESS_REQUIRED,
               PERIOD_NOT_STARTED: appLang.PLANNING__RES_PERIOD_NOT_STARTED,
               BUSY_CLIENT: appLang.PLANNING__BUSY_CLIENT,
               NOT_ENOUGH_SLOTS: appLang.PLANNING__NOT_ENOUGH_SLOTS,
               CLUB_MUST_BE_OPEN_TO_BOOK:
                    appLang.PLANNING__CLUB_MUST_BE_OPEN_TO_BOOK,
               ACTIVITY_OVERLAP: appLang.PLANNING__ACTIVITY_OVERLAPPED,
               MAX_DAILY_LIMIT: appLang.PLANNING__MAX_DAILY_LIMIT,
               BOOK_SESSION_KO: appLang.PLANNING__NO_BOOK_SESSIONS_AVAILABLE,
               MAX_LIMIT: appLang.PLANNING__MAX_LIMIT,
               MAX_TIME_LIMIT: appLang.PLANNING__MAX_TIME_LIMIT,
          };

          if (ctxCode) {
               const v = ERROR_MESSAGES[ctxCode];
               if (v) {
                    this.toastrService.error(ERROR_MESSAGES[ctxCode]);
               } else {
                    this.toastrService.error(appLang.GENERIC_ERROR_MSG);
               }
          } else {
               this.toastrService.error(appLang.GENERIC_ERROR_MSG);
          }
     }
}
